export default function($) {
	let swalDisplayed = false

	$(document.body).on('checkout_error', () => {
		let dawaError = $(".woocommerce-NoticeGroup-checkout li:contains('tilknyttet den indtastede adresse. Kontakt supporten for hjælp.')")
		if (dawaError.length) {
			if ( ! swalDisplayed) {
				// Make sure not to show it twice
				swalDisplayed = true

				if (app_checkout.user.logged_in === true) {
					swal({
						type: 'info',
						title: 'Det ser ud til at du allerede er medlem!',
						text: '<p><a href="'+ app_checkout.login.url +'">Klik her for at komme til din profilside.</a>',
						html: true,
						confirmButtonClass: 'button',
						confirmButtonText: 'Min Profil',
						cancelButtonText: 'Luk',
						showCancelButton: true,
					},
					function( confirm ) {
						if ( confirm ) {
							$('.swal2-confirm').addClass('is-loading')
							window.location = app_checkout.login.url
							return false
						}
					} )
				} else {
					swal({
						type: 'info',
						title: 'Har du fået en prøvepakke før og mangler blade?',
						html: true,
						text: '<form id="swal-login-form" action="' + app_checkout.login.url + '" method="post"<p>Udfyld felterne for at logge ind.</p> <br /> ' +
							      '<div class="field">' +
								        '<input name="username" type="email" class="input" placeholder="E-mail" style="display: block;"/></div>' +
							      '</div>' +
							      '<div class="field">' +
								        '<input name="password" type="password" class="input" placeholder="Adgangskode" style="display: block;"/></div>' +
							      '</div>' +
					             '<p><a href="'+ app_checkout.login.forgot_password_url +'">Glemt adgangskode?</a></p>' +
							      '<input type="hidden" name="woocommerce-login-nonce" value="'+ app_checkout.login.nonce +'" />' +
							      '<input type="hidden" name="redirect" value="'+ app_checkout.login.url +'" />' +
							      '<input type="hidden" name="login" value="1" />',
						confirmButtonClass: 'button',
						confirmButtonText: 'Log ind',
						cancelButtonText: 'Luk',
						showCancelButton: true,
					},
					function( confirm ) {
						if ( confirm ) {
							$('#swal-login-form').submit()
							$('.swal2-confirm').addClass('is-loading')
							return false;
						}
					})
				}
			}
		}
	})
}
